import { useEffect, useRef, useState } from 'react';

const MatrixRain = () => {
  const canvasRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const setSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    setSize();
    window.addEventListener('resize', setSize);

    const chars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789'.split('');
    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    
    const drops = Array(columns).fill(0).map(() => 
      Math.floor(Math.random() * canvas.height / fontSize)
    );

    ctx.fillStyle = '#000500';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = `${fontSize}px monospace`;

    for (let run = 0; run < 150; run++) {
      ctx.fillStyle = 'rgba(0, 5, 0, 0.02)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      for (let i = 0; i < columns; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        
        if (y > 0 && y < canvas.height) {
          const brightness = 0.02 + Math.random() * 0.06;
          ctx.fillStyle = `rgba(0, 255, 65, ${brightness})`;
          ctx.fillText(char, x, y);
        }
        
        drops[i] += 0.3;
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.995) {
          drops[i] = 0;
        }
      }
    }

    let animationId;
    const animate = () => {
      ctx.fillStyle = 'rgba(0, 5, 0, 0.04)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < columns; i++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        if (y > 0 && y < canvas.height) {
          ctx.shadowBlur = 5;
          ctx.shadowColor = 'rgba(0, 255, 65, 0.3)';
          ctx.fillStyle = 'rgba(150, 255, 150, 0.4)';
          ctx.fillText(char, x, y);
          ctx.shadowBlur = 0;
        }

        drops[i] += 0.25 + Math.random() * 0.15;

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.99) {
          drops[i] = 0;
        }
      }

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', setSize);
    };
  }, [mounted]);

  if (!mounted) return null;

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        pointerEvents: 'none',
        opacity: 0.5
      }}
    />
  );
};

export default MatrixRain;
